import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import ReadingTabsListContent from '@/components/reading-tabs/ReadingTabsListContent';
import type { ReadingTabEntry } from '@/utils/reading-tabs';

type Props = {
    open: boolean;
    onClose: () => void;
    tabs: ReadingTabEntry[];
    activeCapId: number | null;
};

export default function ReadingTabsBottomSheet({ open, onClose, tabs, activeCapId }: Props) {
    return (
        <AnimatePresence>
            {open && (
                <>
                    <motion.div
                        key="reading-tabs-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.15 }}
                        className="fixed inset-0 z-[220] bg-black/55 lg:hidden"
                        onClick={onClose}
                        aria-hidden
                    />
                    <motion.div
                        key="reading-tabs-panel"
                        initial={{ y: '100%' }}
                        animate={{ y: 0 }}
                        exit={{ y: '100%' }}
                        transition={{ type: 'spring', damping: 32, stiffness: 320 }}
                        className="fixed bottom-0 left-0 right-0 z-[221] max-h-[min(78vh,520px)] flex flex-col rounded-t-2xl border border-white/10 border-b-0 bg-neutral-950 lg:hidden"
                        style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="reading-tabs-title"
                    >
                        <div className="flex shrink-0 items-center justify-between border-b border-white/[0.06] px-4 py-3">
                            <h2 id="reading-tabs-title" className="text-lg font-semibold text-white">
                                Abas de leitura
                            </h2>
                            <button
                                type="button"
                                onClick={onClose}
                                className="rounded-lg p-2 text-white/45 hover:bg-white/[0.06] hover:text-white"
                                aria-label="Fechar"
                            >
                                <X size={22} />
                            </button>
                        </div>
                        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
                            <ReadingTabsListContent
                                tabs={tabs}
                                activeCapId={activeCapId}
                                onNavigate={onClose}
                                variant="sheet"
                            />
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
